var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-alert",class:("base-alert--" + _vm.variant)},[_c('div',[_c('InfoIcon',{staticClass:"alert__icon",attrs:{"color":"currentColor"}})],1),_c('div',[_vm._t("default")],2),_vm._t("alt")],2)}
var staticRenderFns = []

export { render, staticRenderFns }